import {createSlice, PayloadAction} from "@reduxjs/toolkit";


interface ThankYouScreenState {
  showThankYouScreen: boolean,
  eventTitle?: string,
  donationAmount?: string,
}

const initialState: ThankYouScreenState = {
  showThankYouScreen: false,
};

const thankYouScreenSlice = createSlice({
  name: 'thankYouScreen',
  initialState,
  reducers: {
    updateShowThankYou: (state, action: PayloadAction<ThankYouScreenState>) => action.payload,
    updateShowThankYouScreen: (state, action: PayloadAction<boolean>) => {
      state.showThankYouScreen = action.payload
    }
  }
})

export const {updateShowThankYou, updateShowThankYouScreen} = thankYouScreenSlice.actions;

export default thankYouScreenSlice.reducer;
